import { query_view_1, query_view_2 } from './query';
import { COLUMNS_VIEW_1, COLUMNS_VIEW_2 } from './keys';
import DataTable from '../../../components/Datatable';
import CheckData from '../../../components/CatchError';
import LoadMoreComponent from '../../../components/LoadMoreComponent';
import ExtraButtons from './ExtraBtns';
import { getPercent } from '../../../helpers/showDelta';
import Search from '../../../components/Search';
import { scrollForTable } from '../../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class Urls extends LoadMoreComponent {
    constructor(props) {
        super();
        this.view_query = query_view_1;
        this.query = this.view_query({
            offset: 0,
            status: 'all',
            last_week: props.last_week,
            prior_week: props.prior_week,
        });
        this.offsetStep = 1000;

        this.onSelect = this.onSelect.bind(this);
        this.onRemoveAllSelected = this.onRemoveAllSelected.bind(this);
        this.getData = this.getData.bind(this);
        this.onChangeView = this.onChangeView.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.url?.toLowerCase().includes(search.toLowerCase()));
    }

    async getData(value, search) {
        this.query = this.view_query({
            offset: 0,
            status: value,
            last_week: this.props.last_week,
            prior_week: this.props.prior_week,
            search: search ?? this.state.search,
        });
        this.query.bind(this.setState.bind(this));
        this.setState({ status: value, allData: [] });

        await this.query.update();
    }

    onRemoveAllSelected(bool) {
        this.setState({
            removeAllSelected: bool,
            selectedItems: [],
        });
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({ selectedItems: state.ids, removeAllSelected: false });
    }

    onChangeView(view) {
        if (view === 1) {
            this.view_query = query_view_1;
        } else {
            this.view_query = query_view_2;
        }
        this.setState({ view });
        this.getData('all');
    }

    onSearch(value) {
        this.setState({
            search: value,
        });
        this.getData(this.state.status, value);
    }

    getTable() {
        switch (this.state.view) {
            case 2: {
                return {
                    columns: COLUMNS_VIEW_2(this.props.t),
                    tableStyles: `--data-table-library_grid-template-columns :minmax(60px, 0.5fr) minmax(200px, 3fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important; ${scrollForTable}`,
                    sortKey: 'sortFns_2',
                    defaultSortKey: 'clicks',
                    text: this.props.t('search.urls.table.comparingWeeks', {
                        prior: this.props.prior_week,
                        last: this.props.last_week,
                    }),
                };
            }
            default: {
                return {
                    columns: COLUMNS_VIEW_1(this.props.t),
                    tableStyles: `--data-table-library_grid-template-columns :minmax(60px, 0.5fr) minmax(200px, 3fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important; ${scrollForTable}`,
                    sortKey: 'sortFns_1',
                    defaultSortKey: 'maxClicks',
                    text: null,
                };
            }
        }
    }

    render() {
        const { t } = this.props;

        const attr = {
            query: this.view_query,
            offsetStep: this.offsetStep,
            status: this.state.status,
            last_week: this.props.last_week,
            prior_week: this.props.prior_week,
            search: this.state.search,
        };

        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const sortFns = {
            sortFns_2: {
                url: (array) => array.sort((a, b) => a.url.localeCompare(b.url)),
                keywords: (array) => array.sort((a, b) => a.keywords - b.keywords),
                keywords_delta: (array) =>
                    array.sort(
                        (a, b) =>
                            getPercent(a.keywords, a.keywordsPrior) -
                            getPercent(b.keywords, b.keywordsPrior),
                    ),
                clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
                clicks_delta: (array) =>
                    array.sort(
                        (a, b) =>
                            getPercent(a.clicks, a.clicksPrior) -
                            getPercent(b.clicks, b.clicksPrior),
                    ),
                impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
                impressions_delta: (array) =>
                    array.sort(
                        (a, b) =>
                            getPercent(a.impressions, a.impressionsPrior) -
                            getPercent(b.impressions, b.impressionsPrior),
                    ),
                position: (array) => array.sort((a, b) => a.position - b.position),
                position_delta: (array) =>
                    array.sort(
                        (a, b) =>
                            getPercent(a.position, a.positionPrior) -
                            getPercent(b.position, b.positionPrior),
                    ),
                ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
                ctr_delta: (array) =>
                    array.sort(
                        (a, b) => getPercent(a.ctr, a.ctrPrior) - getPercent(b.ctr, b.ctrPrior),
                    ),
            },
            sortFns_1: {
                url: (array) => array.sort((a, b) => a.url.localeCompare(b.url)),
                clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
                keywords: (array) => array.sort((a, b) => a.keywords - b.keywords),
                impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
                maxClicks: (array) => array.sort((a, b) => a.maxClicks - b.maxClicks),
                avgPosition: (array) => array.sort((a, b) => a.avgPosition - b.avgPosition),
                avgCTR: (array) => array.sort((a, b) => a.avgCTR - b.avgCTR),
            },
        };

        const extraBtns = () => (
            <ExtraButtons
                status={this.state.status}
                getData={this.getData}
                view={this.state.view}
                onChange={this.onChangeView}
                current_url={this.props.current_url}
                csrf_token={this.props.csrf_token}
                selectedItems={this.state.selectedItems?.map((id) => ({
                    id,
                    url: this.state.allData.find((item) => item.id === id).url,
                }))}
                onRemoveAllSelected={this.onRemoveAllSelected}
                t={t}
            />
        );

        const customeSearch = (
            <Search
                onSubmit={this.onSearch}
                placeholder={t('search.urls.placeholder')}
                defaultValue={this.state.search}
            />
        );

        const { columns, tableStyles, sortKey, defaultSortKey } = this.getTable();

        return (
            <div className="card table-main rounded-main overflow-hidden">
                <div className="col-12">
                    <CheckData
                        content_id={this.props.content_id}
                        parent_id={this.props.parent_id}
                        data={this.state.allData}
                        loading={this.state.loading}
                        loadMore={this.state.loadMore}
                        customCheck
                        customCheckCondition={this.state.status !== 'all' || !!this.state.search}
                    >
                        <DataTable
                            nodes={this.state.allData}
                            sortFns={sortFns[sortKey]}
                            COLUMNS={columns}
                            fileName={t('search.urls.table.header')}
                            header={t('search.urls.table.header')}
                            additionalBox={extraBtns}
                            defaultSortKey={defaultSortKey}
                            searchFunction={this.searchFunction}
                            removeAllSelected={this.state.removeAllSelected}
                            hasSelect={true}
                            forceRun={this.forceRun}
                            onSelect={this.onSelect}
                            customeSearch={customeSearch}
                            showLoadMoreBtn={showLoadMoreBtn}
                            loadMoreLoading={this.state.loadMore}
                            loadMore={() => this.loadMore(attr)}
                            additionalStyles={{
                                Table: tableStyles,
                                BaseCell: ` font-family: 'Raleway';
                                                font-weight: 500;
                                                font-size: 16px;
                                                line-height: 19px;
                                                padding: 16px 10px !important;
                                                color: #0D182C;
                                            
                                            
                                                &.underline {
                                                    text-decoration: underline;
                                                };
                                                `,
                            }}
                        />
                    </CheckData>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Urls);
